import * as React from 'react';
import {useState, useEffect, useRef} from 'react';
import {Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Flex, Text, Image, SquareProps, Card, SemanticToken} from '@chakra-ui/react';
import { ICustomer } from '../../../../interfaces/jobsheets/ICustomer';
import * as webHelpers from "../../../../helpers/WebHelpers";
import AcceptedCardImage from "../../../../assets/cards.png";
import AcceptedCardImage2 from "../../../../assets/card_image5.png";
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import { Payment } from 'square';
import { Card as CardObject} from 'square'; //name Card is already used so importerd as CardObject
//import { TokenResult } from 'square'; 
import { Client, Environment, ApiError } from 'square';

interface ISquareProps {
    billingContact: ICustomer | null;
    callback: (token: string, verificationToken: string) => void
}
const square = window.Square;
export default function SquareTokenizeForm(props: ISquareProps) {
    const appId = "sq0idp-hYkN_vRN7_Q8QsQpwVSPhw";
    //const appId = "sandbox-sq0idb-yCbXhfB7FMW6DfrrTQUvKw"; //Sandbox
    const locationId = "LV18QEZ0BJXWP";
    //const locationId = "LVW97TX91JNEG"; //Sandbox

    const [isInProgress, setIsInProgress] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const sendDataToGTM = useGTMDispatch();
    const [previousPayment, setPreviousPayment] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");

    
    async function initializeCard(payments:Payment):Promise<CardObject> {
        const card = await square.payments(appId,locationId).card();

        //Get rid of any old card containers
        const elm = document.getElementById('card-container');
        if (elm) {
            elm.innerHTML = "";
        }

        await card.attach("#card-container");
        return card;
    }

    async function tokenize(paymentMethod:any): Promise<string> {
        const tokenResult = await paymentMethod.tokenize();
        if (tokenResult.status === "OK") {
            return tokenResult.token;
        } else {
            throw new Error(
                `Tokenization errors: ${JSON.stringify(tokenResult.errors)}`
            );
        }
    }

    function displayPaymentResults(status:string) {
        const statusContainer = document.getElementById("payment-status-container");
        if (status === "SUCCESS") {
            setIsError(false);
            setIsSuccess(true);
            sendDataToGTM({event: "card_stored"});
            //@ts-ignore
            //statusContainer.classList.remove("is-failure");
            //@ts-ignore
            //statusContainer.classList.add("is-success");
        } else {
            setIsSuccess(false);
            setIsError(true);
            //@ts-ignore
            //statusContainer.classList.remove("is-success");
            //@ts-ignore
            //statusContainer.classList.add("is-failure");
        }

        //statusContainer.style.visibility = "visible";
        setIsInProgress(false);
    }
    async function verifyBuyer(payments:any, token:string) {
        const verificationDetails = {
            billingContact: {
                addressLines: [
                    props.billingContact?.Billing.Address.line1 ?? "",
                    props.billingContact?.Billing.Address.line2 ?? "",
                    props.billingContact?.Billing.Address.line3 ?? "",
                    props.billingContact?.Billing.Address.line4 ?? "",
                    props.billingContact?.Billing.Address.post_code ?? ""
                ],
                familyName: props.billingContact?.Billing.Contact.LastName,
                givenName: props.billingContact?.Billing.Contact.FirstName,
                email: props.billingContact?.Billing.Contact.EmailAddress,
                phone: props.billingContact?.Billing.Contact.MobileNumber == undefined ? props.billingContact?.Billing.Contact.LandLine : props.billingContact?.Billing.Contact.MobileNumber
            },
            currencyCode: "GBP",
            intent: "STORE",
        };

        const verificationResults = await payments.verifyBuyer(
            token,
            verificationDetails
        );
        return verificationResults.token;
    }

    async function buildForm() {
        if (!square) {
            throw new Error("Square.js failed to load properly");
        }

        let payments: Payment;
        try {
            payments = square.payments(appId, locationId);
        } catch {
            const statusContainer = document.getElementById(
                "payment-status-container"
            );
        if(statusContainer?.className != null){
            statusContainer.className = "missing-credentials";
        }
        if(statusContainer?.style.visibility != null){
            statusContainer.style.visibility = "visible";
        }
            return;
        }

        let card:CardObject;
        try {
            card = await initializeCard(payments);
        } catch (e) {
            console.error("Initializing Card failed", e);
            return;
        }

        async function handlePaymentMethodSubmission(

            event: MouseEvent,
            paymentMethod:CardObject
        ) {
            console.log("test2");
            event.preventDefault();
            setIsError(false);
            setIsSuccess(false);
            setIsInProgress(true);

            try {
                if(cardButton!= null)
                {
                    ((cardButton) as HTMLButtonElement).disabled = true;
                }
                const token:string = await tokenize(paymentMethod);
                let verificationToken:string;
                console.log("payments = ", payments);
                verificationToken = await verifyBuyer(payments, token);
                console.log("verification token = ",verificationToken);
                let response = await props.callback(token, verificationToken);

                console.log("success");
                console.log(response);

                displayPaymentResults("SUCCESS");
            } catch (e:unknown) {
                if (cardButton != null){
                ((cardButton) as HTMLButtonElement).disabled = false;
            }
                displayPaymentResults("FAILURE");
                console.error(e);
            }
        }

        const cardButton = document.getElementById("card-button");
        if (cardButton != null){
        cardButton.addEventListener("click", async function (event) {
            handlePaymentMethodSubmission(event, card);
        })};
    }

    useEffect(() => {
        buildForm();
    }, []);

    return (
        <Flex w='full' direction='column' justifyContent={'center'}>
            <Flex direction='column' w='full' mt={5} justifyContent={'center'}>
                <Flex direction='column' justify='center'>
                    <Flex id='form-container' direction='column' alignItems='center'>
                        <Image src={AcceptedCardImage2} alt='Accepted payment methods' w={294} mb={2}/>
                        <form id="payment-form">
                            <div id="card-container"></div>
                            <Button id='card-button' w='full' colorScheme='blue' isLoading={isInProgress} loadingText="Submitting  " spinnerPlacement='end'>Store</Button>
                            {/* <button id="card-button" type="button">Store</button> */}
                        </form>
                        <div id="payment-status-container"></div>
                        <img id="processing-card" style={{ display: "none" }}/>
                    </Flex>
                </Flex>

                <Flex justify='center' mt={4}>
                    {isSuccess && 
                        <Alert status='success'>
                            <AlertIcon/>
                            <AlertTitle>Verify Card Successful</AlertTitle>
                        </Alert>
                    }
                    {isError &&
                        <Alert status='error'>
                            <AlertIcon/>
                            <Box>
                                <AlertTitle>Verify Card Unsuccessful</AlertTitle>
                                <AlertDescription>Check your details and try again, or contact us for further help.</AlertDescription>
                            </Box>
                        </Alert>
                    }
                </Flex>
            </Flex>
        </Flex>
    );
}